import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { faqPageComponentsMap } from "../../blocks/componentMaps";
import { newTabAttrs } from "../NavLinkAttrs";
import { OrderSupportLayout } from "../OrderSupportLayout";

import styles from "./index.module.scss";

type ISideNav = Immutable<templates.FaqPageTemplate["side_nav"]>;
type ISideNavLink = ISideNav["links"][number];

const SideNavLink = (
    props: Immutable<{ link: ISideNavLink }>,
): React.JSX.Element => {
    return (
        <a href={props.link.url} {...newTabAttrs(props.link)}>
            {props.link.title}
        </a>
    );
};

export const FaqPageBody = (
    props: Immutable<{
        page: templates.FaqPageTemplate["page"];
        side_nav: templates.FaqPageTemplate["side_nav"];
    }>,
): React.JSX.Element => {
    return (
        <OrderSupportLayout
            id="support"
            menu={
                <>
                    <div className="footer__nav--desktop">
                        {props.side_nav.links.map((link) => (
                            <SideNavLink link={link} key={link.url} />
                        ))}
                    </div>
                    <div
                        className="footer__nav--mobile"
                        data-site={props.side_nav.site_hostname}
                        data-menu-name="side"
                        data-menu-calling-page=""
                        data-menu-len={props.side_nav.menu_len}
                    >
                        {props.side_nav.links.map((link) => (
                            <SideNavLink link={link} key={link.url} />
                        ))}
                    </div>
                </>
            }
        >
            <header
                className={styles.faqHeader}
                dangerouslySetInnerHTML={{
                    __html: props.page.body.html,
                }}
            />
            {props.page.blocks ? (
                <StreamField
                    tagName={React.Fragment}
                    value={props.page.blocks.value}
                    components={faqPageComponentsMap}
                />
            ) : null}
        </OrderSupportLayout>
    );
};
